/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const LockLocked: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M12 1C14.7614 1 17 3.23858 17 6V8H19.5C20.6046 8 21.5 8.89543 21.5 10V20.5C21.5 21.6046 20.6046 22.5 19.5 22.5H4.5C3.39543 22.5 2.5 21.6046 2.5 20.5V10C2.5 8.89543 3.39543 8 4.5 8H7V6C7 3.23858 9.23858 1 12 1ZM4.5 20.5H19.5V10H4.5V20.5ZM12 12.5C13.1046 12.5 14 13.3954 14 14.5C14 15.2398 13.5971 15.8835 13 16.2295V18H11V16.2295C10.4029 15.8835 10 15.2398 10 14.5C10 13.3954 10.8954 12.5 12 12.5ZM12 3C10.3431 3 9 4.34315 9 6V8H15V6C15 4.34315 13.6569 3 12 3Z'
      fill='currentColor'
    />
  </React.Fragment>
)
